export type { RoleBaseDesignProps } from './role-base-design';
export * from './role-base-design.routes';

export { default as RoleBaseDesign, default } from './role-base-design';
